<template>
  <div class="tabs_content" v-if="entities">
    <section>
      <div class="status search">
        <div class="field_left">
          <h2 v-translate>Ceny balíčku</h2>
        </div>
        <a
            v-if="$_updateActionAllowed"
            :title="'Přidat cenu balíčku' | translate"
            :class="['add', 'add_expand', { open: newPriceOpen }, { btn_inactive: false}]"
            @click.prevent="toggleNewPrice"
            v-translate>Přidat cenu balíčku
        </a>
      </div>
      <div :class="['filter', 'expand_content', { open: newPriceOpen }]">
        <div class="field_left">
          <p>
            <text-input
                id="newpricevalue"
                v-model="newPrice.value"
                :required="true"
                ref="newpricevalueref"
            >
              <translate class="translate">Hodnota</translate>
            </text-input>
          </p>
          <p>
            <select-box
                id="newpricecurrency"
                :required="true"
                v-model="newPrice.id_currency"
                :options="currencies"
                ref="newpricevalueref"
            >
              <translate class="translate">Měna</translate>
            </select-box>
          </p>
          <p v-if="!$_loggedUser_selectedOperatorId">
            <select-box
                id="newpricebusinessmodel"
                :required="true"
                v-model="newPrice.id_business_model"
                :options="businessModels"
                ref="newpricebusinessmodelref"
            >
              <translate class="translate">Business model</translate>
            </select-box>
          </p>
        </div>
        <div class="field_right field_btn">
          <p class="field">
            <input
                type="submit"
                class="btn"
                :value="'Uložit' | translate"
                @click.prevent.stop="addNewPrice"
            />
          </p>
        </div>
      </div>
      <div class="table_overflow" id="contentBox" data-table-id="vod-packages-prices">
        <table class="vypis vypis_detail">
        <thead>
        <tr v-if="entities.length">
          <th class="no_padding drag_drop"></th>
          <th class="no_padding checkbox"></th>
          <th><span class="name" v-translate>Cena</span></th>
          <th><span class="name" v-translate>Business model</span></th>
          <th><span class="name" v-translate>Operátor</span></th>
          <th><span class="name" v-translate>Název měny</span></th>
          <th><span class="name" v-translate>Upraveno</span></th>
          <th class="no_padding edit"></th>
        </tr>
        </thead>
        <PricesRow v-for="entity in entities"
                    :entity="entity"
                    :key="entity.id"
                    ref="packages_row"
                    :selectedEntities="selectedEntities"
                    @updatePrice="onUpdatePrice"
                    @deletePrice="onDeletePrice"
                    @input="select"/>
        <tr v-if="entities.length === 0">
          <td colspan="8" v-translate>Nebyly nalezeny žádné ceny balíčku.</td>
        </tr>
      </table>
      </div>
      <local-list-action-line
          :entities="entities"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          table-id="vod-packages-prices"
          @select-all="toggleSelectAll"
          @run-multiple-action="runMultipleAction"
      ></local-list-action-line>
    </section>
  </div>
</template>

<script>
import localTable from "@/components/mixins/local-table"
import PricesRow from "./PricesRow.vue";
import message from "../../../mixins/message"

export default {
  name: "Prices",
  components: {PricesRow},
  mixins: [localTable, message],
  props: {
    entity: Object
  },
  data(){
    return {
      tabName: "prices",
      newPriceOpen: false,
      newPrice: {
        value: null,
        id_currency: null,
        id_business_model: null,
      },
      currencies: [],
      businessModels: [],
    }
  },
  created(VodPackageService, CurrencyService, BusinessModelService) {
    this.vodPackageService = VodPackageService;
    this.currencyService = CurrencyService;
    this.businessModelService = BusinessModelService;
    this.currencyService.getEntitiesForSelectBox({}).then((data) => {
      this.currencies = data.currencies;
    });
    if(!this.$_loggedUser_selectedOperatorId) {
      this.businessModelService.getEntitiesForSelectBox({}).then((data) => {
        this.businessModels = data.business_models;
      });
    }
    this.resetNewPrice();
  },
  computed: {
    entities(){
      return this.entity.price;
    },
    csvHeaders(){
      return {
        'formated_value': {name: this.$gettext('Cena')},
        'business_model_name': {name: this.$gettext('Business model')},
        'operator_name': {name: this.$gettext('Operátor')},
        'currency_name': {name: this.$gettext('Název měny')},
        'date_updated': {name: this.$gettext('Upraveno')},
      }
    },
  },
  methods: {
    toggleNewPrice() {
      this.newPriceOpen = !this.newPriceOpen
      if(this.newPriceOpen){
        this.resetNewPrice();
      }
    },
    resetNewPrice(){
      let currency =  this.currencies.length ?  this.currencies[0].id : null;
      let businessModel =  this.businessModels.length ?  this.businessModels[0].id : null;
      this.newPrice = {
        value: null,
            id_currency: currency,
            id_business_model: businessModel,
      };
    },
    addNewPrice() {
      return this.vodPackageService.addVodPackagePrice(this.$route.params.id, {
        'id_selected_operator': this.$_loggedUser_selectedOperatorId,
        'value': this.newPrice.value,
        'id_currency': this.newPrice.id_currency,
        'id_business_model': this.newPrice.id_business_model,
      }).then(() => {
        this.newPriceOpen = false;
        this.$emit("update");
        this.setSuccessMessage();
      }).catch((error) => {
        this.setErrorMessage(error['error_message'])
      });
    },
    onUpdatePrice(data){
      return this.vodPackageService.updateVodPackagePrice(this.$route.params.id, data).then(() => {
        this.$emit("update");
        this.setSuccessMessage();
      }).catch((error) => {
        this.setErrorMessage(error['error_message'])
      });
    },
    onDeletePrice(price_id){
      return this.vodPackageService.deleteVodPackagePrice(this.$route.params.id, {id: price_id}).then(() => {
        this.$emit("update");
        this.setSuccessMessage();
      }).catch((error) => {
        this.setErrorMessage(error['error_message'])
      });
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/vodPackages/detail/Prices.vue